export const PADDLE_FRAME_CLASS = 'paddle-checkout-frame';
export const PADDLE_FRAME_STYLE =
  'width:100%;min-width:312px;background-color:transparent;border:none;';
export const ACTIVATION_POLL_MS = 2_000;
export const ACTIVATION_TIMEOUT_MS = 60_000;
